module.exports = __webpack_public_path__ + "media/images/top/top/img_badge-83467128b0898115100bf28372c0f582.svg";